module.exports = __webpack_public_path__ + "img/shopping.baa4188a.png";